import { createReducer } from '@reduxjs/toolkit';

import type { LayoutStyle, TextSize } from 'mastodon/actions/ui_preferences';
import {
  changeLayoutStyle,
  changeTextSize,
} from 'mastodon/actions/ui_preferences';
import { uiPreferencesSettings } from 'mastodon/settings';

interface UIPreferencesState {
  layoutStyle: LayoutStyle;
  textSize: TextSize;
}

function getInitialState(): UIPreferencesState {
  const partial =
    (uiPreferencesSettings.get(
      'state',
    ) as Partial<UIPreferencesState> | null) ?? {};
  return {
    layoutStyle: partial.layoutStyle ?? 'default',
    textSize: partial.textSize ?? 'large',
  };
}

export const uiPreferencesReducer = createReducer(
  getInitialState,
  (builder) => {
    builder.addCase(changeLayoutStyle, (state, { payload }) => {
      state.layoutStyle = payload;
      uiPreferencesSettings.set('state', state);
    });
    builder.addCase(changeTextSize, (state, { payload }) => {
      state.textSize = payload;
      uiPreferencesSettings.set('state', state);
    });
  },
);
